<div [chart]="chart" id="chart" (dblclick)="resetZones()"></div>
